import EditorFeatureTitle from "../../components/editor/EditorFeatureTitle"
import EditorFeatureSubtitle from "../../components/editor/EditorFeatureSubtitle"

const Suggestions = () => {
	return (
		<div className='bg-white shadow-sm lg:p-9 xl:p-9 2xl:p-10'>
			<EditorFeatureTitle title='Suggestions' />
			<EditorFeatureSubtitle>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit
			</EditorFeatureSubtitle>
			<div className='lg:space-y-4 2xl:space-y-5 lg:mt-7 xl:mt-8 2xl:mt-9'>
				<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center space-x-4'>
					<div className='text-xl font-bold text-1b'>was founded by</div>
					<div className='text-lg text-7d'>may be passive vice</div>
				</div>
				<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center space-x-4'>
					<div className='text-xl font-bold text-1b'>early</div>
					<div className='text-lg text-7d'>can weaken meaning</div>
				</div>
				<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center space-x-4'>
					<div className='text-xl font-bold text-1b'>been ranked</div>
					<div className='text-lg text-7d'>may be passive vice</div>
				</div>
				<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center space-x-4'>
					<div className='text-xl font-bold text-1b'>closely</div>
					<div className='text-lg text-7d'>can weaken meaning</div>
				</div>
			</div>
		</div>
	)
}

export default Suggestions